import React from 'react';

/**
 * DisclosureBadge — small inline badge used to communicate visibility,
 * mode, or status info to a reviewer at the top of a form.
 *
 * Originally introduced for the hr_v1 EPR form (Step 1) and the 360 reviewer
 * disclosure (CLAUDE.md §D.1).
 */

export type DisclosureTone = 'info' | 'success' | 'warning' | 'neutral';

export interface DisclosureBadgeProps {
  icon?: string;        // material-symbols-rounded name
  label: string;
  tone?: DisclosureTone;
}

const TONE_CLASS: Record<DisclosureTone, string> = {
  info:    'bg-stone-100 text-stone-800 border-stone-200',
  success: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  warning: 'bg-amber-50 text-amber-900 border-amber-200',
  neutral: 'bg-white text-stone-700 border-stone-200',
};

const DisclosureBadge: React.FC<DisclosureBadgeProps> = ({ icon, label, tone = 'info' }) => (
  <span
    className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-full border ${TONE_CLASS[tone]}`}
  >
    {icon && (
      <span className="material-symbols-rounded" style={{ fontSize: 14 }} aria-hidden="true">
        {icon}
      </span>
    )}
    {label}
  </span>
);

export default DisclosureBadge;
